import { defineMessages } from 'react-intl'

export default defineMessages({
  noCardInfo: {
    id: 'components.CardListEmpty.noCardInfo',
    defaultMessage: 'Oops!  Currently no cards exist.',
    description: '列表为空展示信息',
  },
  noAccountInfo: {
    id: 'components.CardListEmpty.noAccountInfo',
    defaultMessage: 'Oops!  Currently no accounts exist.',
    description: '列表为空展示信息',
  },
  subInfo: {
    id: 'components.CardListEmpty.subInfo',
    defaultMessage: 'Have a trail on our payment service',
    description: '列表为空展示信息',
  },
})
